import { useState } from 'react';
import { MODULO_VUOTO, type CampoModulo, type ErroriModulo, type ModuloIscrizione } from '@corsi/modulo.ts';
import { azzeramentiCollegati } from './CampiIscrizione';

/**
 * Lo stato del modulo di iscrizione: i valori, gli errori dei campi, e la
 * trappola per i programmi automatici (un campo invisibile che una persona
 * lascia vuoto). Cambiare un campo toglie il suo errore.
 */
export function useModuloIscrizione() {
  const [modulo, setModulo] = useState<ModuloIscrizione>(MODULO_VUOTO);
  const [errori, setErrori] = useState<ErroriModulo>({});
  const [trappola, setTrappola] = useState('');

  function aggiorna<K extends CampoModulo>(campo: K, valore: ModuloIscrizione[K]): void {
    setModulo((attuale) => ({ ...attuale, [campo]: valore, ...azzeramentiCollegati(campo, valore) }));
    setErrori((attuali) =>
      attuali[campo] ? (Object.fromEntries(Object.entries(attuali).filter(([k]) => k !== campo)) as ErroriModulo) : attuali,
    );
  }

  /** Riparte da un modulo vuoto, o con alcuni campi gia' scritti. */
  function reimposta(precompilati: Partial<ModuloIscrizione> = {}): void {
    setModulo({ ...MODULO_VUOTO, ...precompilati });
    setErrori({});
  }

  return { modulo, errori, setErrori, aggiorna, reimposta, trappola, setTrappola };
}
